module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8 title"
  }, [_vm._v(_vm._s(_vm.$t(_vm.title)) + " "), (_vm.count) ? _c('strong', [_vm._v(_vm._s(_vm.count))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-4 action"
  }, [_c('span', {
    on: {
      "click": _vm.viewDetail
    }
  }, [_vm._v(_vm._s(_vm.$t('common.more')) + " >")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54010d8f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-main/components/CatSubtitle.vue
// module id = 1575
// module chunks = 1